

import { useContext, useEffect, useState } from 'react';
import { CurrentPContext, MasterContext, MobiOrNotContext, OrderContext, UserContext } from '../ContextApi/context';

import { useHistory } from "react-router-dom";
import OrderFunctions from './OrderFunctions';

import Scroll from 'react-scroll';
import Minimum_Order from '../DTechComp/Pop_Fixed/Minimum_Order';
import UserAdresses from '../UsersLogs/UserAdresses';


var scroller = Scroll.scroller;

const GetTheAddress = (props) => {



    const [master, setMaster] = useContext(MasterContext);
    const [order, setOrder] = useContext(OrderContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);
    const [mobiOrNot] = useContext(MobiOrNotContext);
    const [user, UserEffectFunction] = useContext(UserContext);
    const [thePopUp, setThePopUp] = useState("");
    const [yellowLineTxt, setYellowLineTxt] = useState("המשך לתשלום");
    const [payType, setPayType] = useState((order.payt != null) ? order.payt : "1");
    const [showContBtn, setShowContBtn] = useState(true);
    const [kopon, setKopon] = useState("")
    const [koponMsg, setKoponMsg] = useState("")
    const [approvedKoponMsg, setApprovedKoponMsg] = useState("")
    const [dataBk, setDataBk] = useState("")

    const history = useHistory();

    let popTiming = 0;

    useEffect(() => {

        getAddress();
    }, [])

    useEffect(() => {

    }, [order])

    const getAddress = async () => {

        await setToDeliver();

    }

    const setTheAddress = (theSele) => {
        order.deliveryAddress = theSele;
        //מכניס את הכתובת הרצוייה
        order["deliveryAddress"] = theSele;
        let tempOrd = { ...order };
        tempOrd.deliveryAddress = theSele;
        setOrder({ ...tempOrd });
    }



    const checkIfEnterOnKop = (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
        }
    }

    //אופן התשלום השתנה ופה מעדכנים את ההזמנה
    const paytypChanched = (ptyp) => {
        setPayType(ptyp);
        let ordTemp = { ...order };
        ordTemp.payt = ptyp;
        setOrder({ ...ordTemp });

    }

    const GoTOPay = () => {
        props.GoTOPay(order.deliveryAddress);
    }


    const backToRestMenu = () => {
        history.push(`/restaurants/${currentPage.pageUrlFix != null && currentPage.pageUrlFix != "" ?
            currentPage.pageUrlFix : currentPage._id}`)
    }

    const checkForAddress = () => {
        props.closeMeFuc();
        if (props.allowBack) {
            (!order.deliveryAddress || order.deliveryAddress === undefined) &&
                backToRestMenu();
        }

    }

    //המשך הזמנה כמשלוח
    const setToDeliver = async () => {
        let theCurrnt = (props.restPage) ? props.restPage : currentPage;
        if (Array.isArray(theCurrnt.cityesToDeliver) && theCurrnt.cityesToDeliver.length > 0) {
            //בודק אם מוגדר מינימום מחיר למשלוח
            //במידה וכן עובד לפי המחיר המוגדר
            //במידה ולא, עובד לפי המינימום המוגדר במאסטר
            let mindelP = (theCurrnt.Delivery.MiniDelPrice != null &&
                theCurrnt.Delivery.MiniDelPrice != "") ?
                theCurrnt.Delivery.MiniDelPrice : master.MiniDelPrice;

            //רק במידה ומחיר המינימום למשלוח הושג.
            if (parseInt(OrderFunctions.getOrderPrice(order)) >= parseInt(mindelP)) {

                popTiming++;
                setDataBk(
                    <div key={popTiming} id={"addressBox"} className={"addressBox"}>
                        <UserAdresses noHead={true} closeMe={() => { checkForAddress(); }} addId={"SelectAdd"}
                            setTheAddress={(theSele) => setTheAddress(theSele)}
                            deliveryCitys={theCurrnt.cityesToDeliver}
                            GoTOPay={() => GoTOPay()} /></div>
                )
                setTimeout(function () {
                    scroller.scrollTo(`addressBox`, { smooth: true, offset: 0, duration: 1000 });
                }, 20)

            }
            else {

                popTiming++;
                setDataBk(
                    <Minimum_Order
                        okClick={() => {
                            props.closeMeFuc();
                        }}
                        mindelP={mindelP}
                        okClick1={() => { props.goBackToMenu(); }}
                        okClick2={() => { props.closeMeFuc(); }}
                        master={master}
                    />
                )
            }
        }


    }

    return (
        dataBk
    )


}
export default GetTheAddress;

